import { Box, IconButton } from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import {
  EyeIcon,
  PencilSquareIcon,
  TrashIcon,
} from "@heroicons/react/24/outline";

export default function ProduitsTable({
  produits,
  setSelectedRows,
  setProduitSelectionne,
  setOpenFicheProduit,
  setOpenEdition,
  setOpenDeleteModal,
  userRole,
}) {
  const columns = [
    { field: "code_isin", headerName: "Code ISIN", width: 200 },
    { field: "nom_produit", headerName: "Nom du Produit", width: 380 },
    { field: "societe_gestion", headerName: "Société", width: 280 },
    { field: "type", headerName: "Catégorie", width: 200, align: "center", headerAlign: "center" },
    { field: "risque", headerName: "Risque", width: 130, type: "number", align: "center", headerAlign: "center" },
    {
      field: "prospectus",
      headerName: "Prospectus",
      width: 130,
      renderCell: (params) =>
        params.row.lien_dic ? (
          <a
            href={params.row.lien_dic}
            target="_blank"
            rel="noopener noreferrer"
            style={{ color: "blue", textDecoration: "underline" }}
          >
            Voir PDF
          </a>
        ) : (
          <span style={{ color: "gray" }}>Non disponible</span>
        ),
    },
    {
      field: "actions",
      headerName: "Actions",
      width: 240,
      align: "center",
      headerAlign: "center",
      renderCell: (params) => (
        <Box display="flex" justifyContent="center" alignItems="center" gap={1} width="100%">
          <IconButton
            color="primary"
            onClick={() => {
              setProduitSelectionne(params.row);
              setOpenFicheProduit(true);
            }}
          >
            <EyeIcon className="w-5 h-5" />
          </IconButton>
          <IconButton
            color="warning"
            onClick={() => {
              setProduitSelectionne(params.row);
              setOpenEdition(true);
            }}
          >
            <PencilSquareIcon className="w-5 h-5" />
          </IconButton>
    
          {/* 👇 Affiche le bouton supprimer seulement si rôle autorisé */}
          {(userRole === "Associé" || userRole === "Administrateur") && (
            <IconButton
              color="error"
              onClick={() => {
                console.log("🗑️ Suppression demandée pour :", params.row.nom_produit);
                setProduitSelectionne(params.row);
                setOpenDeleteModal(true);
              }}
            >
              <TrashIcon className="w-5 h-5" />
            </IconButton>
          )}
        </Box>
      ),
    },    
  ];

  return (
    <Box sx={{ height: 745, width: "100%", marginBottom: 3 }}>
      <DataGrid
        rows={produits.map((p) => ({ id: p._id, ...p }))}
        columns={columns}
        checkboxSelection
        disableRowSelectionOnClick
        rowHeight={45}
        onRowSelectionModelChange={(ids) => setSelectedRows(ids)}
        localeText={{ noRowsLabel: "Aucun résultat trouvé" }}
        pageSizeOptions={[10, 20, 50, 100]}
        pagination
      />
    </Box>
  );
}
